/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Column_First_NameInputs */

const en_admin_user_list_column_first_name = /** @type {(inputs: Admin_User_List_Column_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`first name`)
};

const de_admin_user_list_column_first_name = /** @type {(inputs: Admin_User_List_Column_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "first name" |
*
* @param {Admin_User_List_Column_First_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_column_first_name = /** @type {((inputs?: Admin_User_List_Column_First_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Column_First_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_column_first_name(inputs)
	return en_admin_user_list_column_first_name(inputs)
});